import { render, staticRenderFns } from "./CategoryEdit.vue?vue&type=template&id=5f193088&scoped=true&"
import script from "./CategoryEdit.vue?vue&type=script&lang=js&"
export * from "./CategoryEdit.vue?vue&type=script&lang=js&"
import style0 from "./CategoryEdit.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CategoryEdit.vue?vue&type=style&index=1&id=5f193088&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f193088",
  null
  
)

export default component.exports